module.exports = __webpack_public_path__ + "static/LaunchTrailerFinal-small2-f27a99dd6071b227bf779c630cfeef77.mp4";